import {type ChangeEvent, useState} from 'react';
import {useDebounce} from '../hooks';
import {SearchInput} from './SearchInput';

export type DebouncedSearchInputProps = {
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  wrapperClassName?: string;
};

export function DebouncedSearchInput({
  onChange,
  placeholder,
  className,
  wrapperClassName,
}: DebouncedSearchInputProps) {
  const [searchValue, setSearchValue] = useState('');

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  useDebounce(searchValue, 500, value => {
    if (value.length > 2 || value.length === 0) {
      onChange(value);
    }
  });

  return (
    <SearchInput
      onChange={handleInputChange}
      placeholder={placeholder}
      className={className}
      wrapperClassName={wrapperClassName}
    />
  );
}
